import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import IconRadio from "./IconRadio";
import styles from "./styles";
import { FieldRenderProps } from "react-final-form";

interface Props {
  id: string;
  name: string;
  input?: any;
  meta?: any;
  label: string;
  items: { label: string; value: string }[];
  required?: boolean;
  onChange?(value: string): void;
  disabled?: boolean;
}

const InputRadio: React.FC<Props & FieldRenderProps<any, HTMLElement, any>> = ({
  id,
  name,
  input,
  meta: { error, touched, initial },
  label,
  items,
  required = false,
  disabled,
  onChange,
}) => {
  const [value, setValue] = useState<string | undefined>(
    input?.value || initial || ""
  );

  useEffect(() => {
    const newValue = input?.value || initial;
    setValue(newValue);
  }, [input?.value, initial, items]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    if (input) {
      input.onChange(selectedValue);
    }
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <>
      <FormControl className="root" sx={styles}>
        <FormLabel className="formLabel">
          {label} {required && "*"}
        </FormLabel>
        <RadioGroup
          className="radioGroup"
          name={input.name}
          value={value}
          onChange={handleChange}
          row
        >
          {items.map((item) => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              value={item.value}
              disabled={disabled}
              control={
                <Radio
                  icon={<IconRadio />}
                  checkedIcon={<IconRadio checked />}
                />
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
      {error && touched && (
        <Typography
          color="error"
          variant="caption"
          // 200px + 24px + 8px margin of label & radios
          sx={{ ml: "234px" }}
        >
          {error}
        </Typography>
      )}
    </>
  );
};

export default InputRadio;
